export default __webpack_public_path__ + "static/media/GreenCats60s.a7e40b2d.mp3";